import Actions from '../../../../../common/ui/actions';
import { useState } from 'react';
import { EditIcon, LockIcon } from '../../../../../common/ui/icons';
import DeleteStoragePlace from '../actions/delete-storage-place';
import { IStoragePlace } from '../../../interior-organizer-interfaces';
import UpsertStoragePlace from '../actions/upsert-storage-place';
import { markdown2Html } from '../../../../../common/markdown/markdown-provider';
import DuplicateStoragePlace from '../actions/duplicate-storage-place';

interface IStoragePlaceProps {
    storagePlace: IStoragePlace;
    index: number;
}

enum StoragePlaceMode {
    Default = 0,
    Edit = 1,
}

const StoragePlace = ({ storagePlace, index }: IStoragePlaceProps) => {

    const [mode, setMode] = useState<StoragePlaceMode>(StoragePlaceMode.Default);

    const startEdit = () => {
        setMode(StoragePlaceMode.Edit);
    };

    const stopEdit = () => {
        setMode(StoragePlaceMode.Default);
    };

    return (
        <div className="border-b pb-2 mb-2">
            {
                mode === StoragePlaceMode.Default &&
                (
                    <>
                        <div className="flex items-center">
                            <div className="mr-4 rounded text-xs">
                                { index }
                            </div>

                            <div className="grid md:grid-cols-[auto_auto] gap-x-10 gap-y-2 mr-6 flex-1">
                                <button
                                    onClick={ startEdit }
                                    className="text-left"
                                    type="button"
                                    dangerouslySetInnerHTML={ {
                                        __html: markdown2Html(storagePlace.name)
                                    } }
                                />

                                <div className="text-teal-700 md:text-right">
                                    { storagePlace.width } x { storagePlace.height } x { storagePlace.depth }
                                </div>
                            </div>

                            {
                                !!storagePlace.is_full &&
                                <LockIcon
                                    size={ 20 }
                                    color={ '#1c3f55' }
                                />
                            }

                            {
                                !storagePlace.is_full &&
                                <div style={{
                                    width: '20px',
                                    height: '5px',
                                }}>&nbsp;</div>
                            }

                            <Actions classes="interior-organizer__places__actions" mr="mr-0" ml="ml-0" gridSize={ 3 }>
                                <DeleteStoragePlace storagePlace={ storagePlace }/>

                                <button
                                    title="Edit Business"
                                    className="interior-organizer__places flex bg-slate-200 rounded mx-1 text-left justify-center items-center whitespace-nowrap action-btn"
                                    onClick={ startEdit }
                                    type="button">
                                    <EditIcon color={ '#6e7781' } size={ 20 }/>
                                </button>

                                <DuplicateStoragePlace storagePlace={ storagePlace } />
                            </Actions>
                        </div>

                        {
                            storagePlace.description &&
                            <div
                                className="ml-7 markdown-editor mt-2 bg-slate-100 px-4 py-2 rounded"
                                dangerouslySetInnerHTML={ {
                                    __html: markdown2Html(storagePlace.description)
                                } }
                            />
                        }
                    </>
                )
            }

            {
                mode === StoragePlaceMode.Edit &&
                <UpsertStoragePlace
                    storagePlace={ storagePlace }
                    close={ stopEdit }
                />
            }
        </div>
    )
};

export default StoragePlace;